import { Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout/Layout';
import Home from './pages/Home';
import CollegeSearch from './pages/CollegeSearch';
import CollegeDetails from './pages/CollegeDetails';
import CutoffComparison from './pages/CutoffComparison';
import CollegePredictor from './pages/CollegePredictor';
import DistrictRankings from './pages/DistrictRankings';
import BestColleges from './pages/BestColleges';
import About from './pages/About';
import Contact from './pages/Contact';
import PrivacyPolicy from './pages/PrivacyPolicy';
import ChoiceList from './pages/ChoiceList';
import AdminLeads from './pages/AdminLeads';
import AdminLogin from './pages/AdminLogin';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <Routes>
      {/* Public site — with header/footer/banner */}
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="colleges" element={<CollegeSearch />} />
        <Route path="colleges/:code" element={<CollegeDetails />} />
        <Route path="cutoffs" element={<CutoffComparison />} />
        <Route path="predictor" element={<CollegePredictor />} />
        <Route path="district-rankings" element={<DistrictRankings />} />
        <Route path="best-colleges" element={<BestColleges />} />
        <Route path="about" element={<About />} />
        <Route path="contact" element={<Contact />} />
        <Route path="privacy-policy" element={<PrivacyPolicy />} />
        <Route path="choicelist" element={<ChoiceList />} />
      </Route>

      {/* Admin — bare layout, no public header/footer */}
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin/leads" element={
        <ProtectedRoute><AdminLeads /></ProtectedRoute>
      } />

      {/* Redirect /admin → /admin/leads */}
      <Route path="/admin" element={<Navigate to="/admin/leads" replace />} />
    </Routes>
  );
}

export default App;
